import { action, computed } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import TransactionalMessageModel, {
  ContentSource,
  TransactionalMessageChannelType,
  TransactionalMessageUpdateType,
} from 'cio/models/transactional-message';
import TransactionalSetupBaseController from 'cio/pods/transactional/message/setup/base-controller';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import RouterService from '@ember/routing/router-service';
import ApiErrorsService from 'cio/services/api-errors';

export default class TransactionalMessageSetupIndexController extends TransactionalSetupBaseController {
  @service auth!: AuthService;
  @service router!: RouterService;
  @service apiErrors!: ApiErrorsService;

  ContentSource = ContentSource;
  MessageType = TransactionalMessageChannelType;

  declare model: TransactionalMessageModel;

  @computed('model.hasDirtyAttributes')
  get isDirty() {
    return this.model.hasDirtyAttributes;
  }

  @action
  updateType(type: TransactionalMessageChannelType) {
    this.model.set('type', type);
  }

  updateTypeTask = dropTask(async (type: TransactionalMessageChannelType) => {
    try {
      this.model.setProperties({
        type,
        updateType: TransactionalMessageUpdateType.Channel,
      });

      await this.model.save();
    } catch (e) {
      this.model.rollbackAttributes();
      this.apiErrors.report(e);
    }

    await this.model.hasMany('templates').reload();
  });

  editMessageTask = dropTask(async () => {
    try {
      if (Boolean(this.model.hasDirtyAttributes) && this.auth.hasPermission('journeys/transactional_messages/edit')) {
        this.model.set('updateType', TransactionalMessageUpdateType.ContentSource);
        await this.model.save();
      }

      this.router.transitionTo('composer.transactional', this.model.id);
    } catch (e) {
      this.apiErrors.report(e);
    }
  });

  saveTask = dropTask(async () => {
    try {
      this.model.set('updateType', TransactionalMessageUpdateType.ContentSource);
      await this.model.save();
      this.router.transitionTo('transactional.message.setup.settings', this.model);
    } catch (e) {
      this.apiErrors.report(e);
    }
  });

  resetTask = dropTask(async () => {
    this.model.rollbackAttributes();
  });
}

declare module '@ember/controller' {
  interface Registry {
    'transactional-message-setup-index': TransactionalMessageSetupIndexController;
  }
}
